/** EmptyState: what a card says when it has nothing to list: an icon, one line, a hint and one way out. Also the error and all-clear states. */
import type { ReactNode } from "react";
import { cx } from "./cx";
import { Icon, type IconName } from "./icons";

interface EmptyStateProps {
  icon?: IconName;
  title: string;
  hint?: string;
  /** `alert` for a failure, so it is announced. */
  role?: "alert" | "status";
  /** One action (a kit Button): Reset, Try again. */
  children?: ReactNode;
  className?: string;
}

export function EmptyState({ icon = "search", title, hint, role, children, className }: EmptyStateProps) {
  return (
    // Sized, not padded: the reference's empty table is a centred column in a fixed box, so this is too.
    <div role={role} className={cx("flex min-h-32 w-full animate-fade flex-col items-center justify-center gap-1.5 text-center", className)}>
      <Icon name={icon} size={18} className="opacity-60" />
      <p className="text-body font-medium text-foreground">{title}</p>
      {hint && <p className="text-meta text-muted-foreground">{hint}</p>}
      {children && <div className="mt-1 flex items-center gap-2">{children}</div>}
    </div>
  );
}
